import api from "@/api";

export default {
    state: {
        mandates: [],
        mandatesLoading: false,
        mandateEmailModal: {
            display: false,
            mandateId: null,
        },
    },
    getters: {
        mandates: (state) => state.mandates, 
        mandatesLoading: (state) => state.mandatesLoading,
        mandateEmailModal: (state) => state.mandateEmailModal,
    },
    mutations: {
        setMandates(state, mandates) {
            state.mandates = mandates;
        },
        setMandatesLoading(state, status) {
            state.mandatesLoading = status;
        },
        setMandateEmailModal(state, payload) {
            state.mandateEmailModal = payload;
        }
    }, 
    actions: {
        async fetchMandates({ commit }, customerId) {
            if (!customerId) {
                commit('setMandates', []);
                return;
            }

            commit('setMandatesLoading', true);
            try {
                const response = await api({ requiresAuth: true })
                .get(`/v1/customers/${customerId}/mandates`);
                
                const data = response.data.data || response.data || [];
                commit('setMandates', data);
            } catch (error) {
                console.error("Error fetching mandates:", error);
                commit('setMandates', []);
                throw error;
            } finally {
                commit('setMandatesLoading', false);
            }
        },

        async createMandate({ dispatch, commit }, { customer_id, mandate_type_id, agent_id, notice_agent_id }) {
            try {
                const response = await api({ requiresAuth: true }).post(`v1/customers/${customer_id}/mandates`, {
                    customer_id,
                    mandate_type_id,
                    agent_id,
                    notice_agent_id,
                });
 
                commit("setToast", {
                    display: true,
                    type: "success",
                    message: response.data.message || "Mandate created successfully.",
                }, { root: true });  

                
                await dispatch("fetchMandates", customer_id); 

            } catch (error) { 
                commit("setToast", {
                    display: true,
                    type: "error",
                    message: error.response?.data?.message || "Could not create mandate." 
                }, { root: true }); 
                throw error;
            }
        },

        async downloadMandatePDF(_, { customerId, mandateId, name }) { 
            try {
                const response = await api({ requiresAuth: true }).get(
                `/v1/customers/${customerId}/mandates/${mandateId}/generate-pdf`,
                { responseType: 'blob' }
                );
 
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Mandat ${name}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error("Error downloading mandate:", error);
                throw error;  
            }
        },

        async sendMandateEmail(_, { customer_id, mandate_id, deliveries }) {
            try {
                const response = await api({ requiresAuth: true }).post(
                    `/v1/customers/${customer_id}/mandates/${mandate_id}/company-deliveries`,
                    {
                        deliveries,
                    }
                );

                return response.data;
            } catch (error) {
                console.error("Error sending mandate email:", error);
                throw error;
            }
        },

        async updateDeliveryStatus(_, { deliveryId, status }) {
            try {
                const statusId = status.id || status;
                await api({ requiresAuth: true }).patch(
                    `/v1/customer-mandate-company-deliveries/${deliveryId}/status`,
                    {
                        status_id: statusId,
                    }
                );
            } catch (error) {
                console.error("Error updating delivery status:", error);
                throw error;
            }
        }
    }
}